import React, { useState, useEffect, ReactElement, useRef } from "react";
import clsx from "clsx";

import { ReactComponent as IconCaret } from "../../assets/svg/caret_up.svg";
import { ReactComponent as IconCheck } from "../../assets/svg/check.svg";
import useOnClickOutside from "../../hooks/useOnClickOutside";

import styles from "./GroupSettingClassDropdown.module.scss";
export type Option = {
  value: number;
  label: string | ReactElement;
  data?: any;
};

export type Props = {
  options: Option[];
  placeholder?: string;
  defaultValue?: Option;
  onChange: (value: number, data?: any) => void;
};

const TEXT_NO_DATA = "データがありません";

export const GroupSettingClassDropdown: React.FC<Props> = ({
  options,
  placeholder,
  defaultValue,
  onChange,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [optionSelected, setOptionSelected] = useState<Option>({
    value: -1,
    label: TEXT_NO_DATA,
    data: null,
  });

  useEffect(() => {
    if (
      defaultValue === undefined &&
      optionSelected.value === -1 &&
      options.length !== 0
    ) {
      placeholder
        ? setOptionSelected({ value: -1, label: placeholder })
        : setOptionSelected(options[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, defaultValue]);

  useEffect(() => {
    if (optionSelected.value !== -1) {
      onChange(optionSelected.value, optionSelected.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionSelected.value]);

  useEffect(() => {
    if (defaultValue) {
      setOptionSelected({
        value: defaultValue.value,
        label: defaultValue.label,
        data: defaultValue.data,
      });
    }
  }, [defaultValue]);

  const labelChange = (option: Option) => {
    if (options.length === 0) return TEXT_NO_DATA;

    const existsInOptions = options.some(o => o.value === option.value);
    return existsInOptions ? option.label : placeholder;
  };

  const handleClickOutside = () => setOpen(false);

  useOnClickOutside(ref, handleClickOutside);

  return (
    <div ref={ref} className={styles.wrapSelect} onClick={() => setOpen(!open)}>
      <div className={styles.option}>
        <div className={styles.label}>{labelChange(optionSelected)}</div>
        <IconCaret />
      </div>
      {open && options.length !== 0 && (
        <div className={styles.optionsWrapper}>
          <div className={styles.options}>
            {options.map(item => (
              <div
                className={clsx(
                  styles.option,
                  item.value === optionSelected.value && styles.active,
                )}
                onClick={() => {
                  setOptionSelected(item);
                }}
                key={item.value}
              >
                <div className={styles.label}>{item.label}</div>
                <IconCheck />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default GroupSettingClassDropdown;
